<template>
  <el-form ref="form" :model="form" :inline="true" size="mini">
    <el-row>
      <el-col :sm="{span: 4}" :xl="{span: 2}">
        <el-form-item prop="recommendStatusList" >
          <el-checkbox-group size="mini" v-model="form.recommendStatusList">
            <el-checkbox label="T">已推荐</el-checkbox>
            <el-checkbox label="N">未推荐</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-col>
      <el-col :sm="{span: 4}" :xl="{span: 2}">
        <el-form-item prop="choiceStatusList">
          <el-checkbox-group size="mini" v-model="form.choiceStatusList">
            <el-checkbox label="C">已选中</el-checkbox>
            <el-checkbox label="N">未反馈</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-col>
      <el-col :sm="{span: 4}" :xl="{span: 2}">
        <el-form-item prop="quotationStatusList">
          <el-checkbox-group size="mini" style="width: 100%;" v-model="form.quotationStatusList">
            <el-checkbox label="Q">已报价</el-checkbox>
            <el-checkbox label="N">未报价</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-col>
      <el-col :sm="{span: 4}" :xl="{span: 2}">
        <el-form-item prop="linkPrjStatusList">
          <el-checkbox-group size="mini" style="width: 100%;" v-model="form.linkPrjStatusList">
            <el-checkbox label="P">已打样</el-checkbox>
            <el-checkbox label="N">无</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-col>
      <el-col :sm="{span: 4}" :xl="{span: 2}">
        <el-form-item>
          <el-button style="float: left" type="primary" @click="query">
<!--            <d2-icon name="search" />-->
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button style="float: left" @click="reset" class="d2-mr-10">
<!--            <d2-icon name="refresh" />-->
            重置
          </el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>

export default {
  props: {
    params: {
      default: null,
      type: Object
    }
  },
  watch: {
    params: {
      handler () {
        this.form.prjCode = this.params.prjCode
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      form: {
        prjCode: '',
        productNo: '', // 产品款号
        productType: '', // 产品类型（S-样品资料，D-素材资源，R-市调产品）
        recommendStatusList: [], // 推荐状态
        choiceStatusList: [], // 选中状态
        quotationStatusList: [], // 报价状态
        linkPrjStatusList: []// 打样状态
      }
    }
  },
  methods: {
    query () {
      this.$emit('submit', this.form)
    },
    reset () {
      this.$refs.form.resetFields()
      this.query()
    }
  }
}
</script>
